import React, { useContext } from 'react';

import { Button } from '@vimeo/bokeh';

import BpTracking from '../../utils/bpTracking';
import { appendTrackingQueryParams } from '../../utils/utils';
import TrackingContext from './TrackingContext';

interface Props {
  text: string;
  link: string;
}

const SecondaryCTAButton = (props: Props) => {
  const trackingProps = useContext(TrackingContext);

  const handleClick = () => {
    BpTracking.trackButtonClick(
      {
        ...trackingProps.params,
        copy: props.text,
        device_type: trackingProps.device_type,
        path: window.location.href,
        target: window.location.pathname,
        target_path: props.link,
      },
      trackingProps.bpEventVersion,
    );

    if (trackingProps.onButtonClick) {
      trackingProps.onButtonClick({
        copy: props.text,
        target_path: appendTrackingQueryParams(props.link, trackingProps.params),
      });
    }
  };

  return (
    <Button
      data-testid="upsell-secondary-cta"
      size="md"
      variant="minimal"
      href={appendTrackingQueryParams(props.link, trackingProps.params)}
      target="_blank"
      as="a"
      onClick={handleClick}
      width="100%"
    >
      {props.text}
    </Button>
  );
};

export default SecondaryCTAButton;
